import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import PageTitle from 'components/PageTitle';
import Button from 'components/Button';
import Input from 'components/Input';

import { setStorage } from 'utilz';
import containerActions from './actions';

// eslint-disable-next-line
import { URLS } from 'config';

import './styles.scss';

export const chekYears = birthday => birthday.indexOf('') === -1
  ? moment.duration(moment(new Date())
    .diff(moment(`${birthday[4]}${birthday[5]}${birthday[6]}${birthday[7]}-${birthday[2]}${birthday[3]}-${birthday[0]}${birthday[1]}`))).years()
  : 0;

class BirthdayPage extends React.Component {
  constructor () {
    super();
    this.state = {
      countInputs: (new Array(8).fill(''))
    };
  }
  componentWillMount() {
    // eslint-disable-next-line
    // if (this.props.birthday && chekYears(this.props.birthday) === NaN
    // && chekYears(this.props.birthday) >= 18 && chekYears(this.props.birthday) <= 75) {
    //   this.props.history.push(URLS.GENDER);
    // }
    if (this.props.birthday.length === 8) {
      this.setState({
        countInputs: this.props.birthday
      });
    }
  }

  componentDidMount() {
    this.inputs[0].focus();
  }

  componentWillUnmount() {
    setStorage({
      birthday: {
        birthday: this.props.birthday
      }
    });
  }

  inputs = [];
  // countInputs = new Array(8).fill(0);
  // goToNext = true;

  moveCursorNext = (index) => {
    if (this.inputs[index + 1]) this.inputs[index + 1].focus();
  }
  moveCursorForvard = (index) => {
    if (this.inputs[index - 1]) this.inputs[index - 1].focus();
  }
  inputAction = index => (e) => {
    const countInputsTemp = this.state.countInputs;
    const chr = e.key;

    if (e.keyCode === 8) {
      countInputsTemp[index] = '';
      this.setState({
        countInputs: countInputsTemp
      });
      this.moveCursorForvard(index);
      this.props.birthdayChangeHandl(countInputsTemp);
      return;
    }
    if (chr == null) return;
    if (chr < '0' || chr > '9') {
      return;
    }
    if (countInputsTemp[index].length > 0) {
      if (countInputsTemp[index + 1] !== undefined) countInputsTemp[index + 1] = chr;
    }
    if (countInputsTemp[index].length === 0) countInputsTemp[index] = chr;

    this.setState({
      countInputs: countInputsTemp
    });
    this.moveCursorNext(index);
    this.props.birthdayChangeHandl(countInputsTemp);
  }
  // inputChangeHandl = index => (e) => {
  //   const { target: { value } } = e;

  //   if (value === '') {
  //     this.goToNext = false;
  //   } else {
  //     this.goToNext = true;
  //   }


  //   if (value.length >= 2) {
  //     return;
  //   }

  //   const birthday = [...this.props.birthday];

  //   birthday.splice(index, 1, value);
  //   this.props.birthdayChangeHandl(birthday);
  // }

  saveBirthdayHandl = () => {
    const nextRoute = this.props.location.state && !this.props.location.state.goToGender
      ? URLS.WORKING : URLS.GENDER;

    this.props.birthdaySend(() => {
      this.props.history.push(nextRoute);
    });
  }

  checkDateValidation = (element, index) => {
    const prevElement = this.props.birthday[index - 1];
    const number = element ? +element : null;
    let isError = false;
    if (number > 3 && index === 0) {
      isError = true;
    }

    if (index === 1 && prevElement >= 3 && number > 1) {
      isError = true;
    }

    if (index === 2 && number > 1) {
      isError = true;
    }

    if (index === 3 && prevElement >= 1 && number > 2) {
      isError = true;
    }

    if (index === 4 && number > 2) {
      isError = true;
    }

    return isError;
  }

  dateValidatonState = () => {
    const value = this.props.birthday.map(this.checkDateValidation);
    const idx = value.filter(el => el === true);

    return idx.length === 0;
  }
  renderPlaceholder = (index) => {
    if (index === 0 || index === 1) {
      return 'D';
    }

    if (index === 2 || index === 3) {
      return 'M';
    }

    // console.log(length);
    return 'Y';
  }


  render() {
    return (
      <div className="page-birthday -not-full">
        <PageTitle>
            Your birthday
        </PageTitle>
        <div className="birthday-input">

          {
            this.state.countInputs.map((el, index, arr) => (
              // eslint-disable-next-line
              <React.Fragment key={index}>
                <div className="phone-input" >
                  <Input
                    type="tel"
                    placeholder={this.renderPlaceholder(index, arr.length - 1)}
                    reference={(element) => { this.inputs.push(element); }}
                    // changeHandl={this.inputChangeHandl(index)}
                    isError={this.checkDateValidation(this.props.birthday[index], index)}
                    value={this.props.birthday[index] ? this.props.birthday[index] : ''}
                    isFloating={false}
                    keyAction={this.inputAction(index)}
                  />
                </div>
                {
                   index === 1 || index === 3 ? <p className="separator">/</p> : null
                }
              </React.Fragment>
            ))
          }
        </div>
        <p className="error-text">
          {
            // eslint-disable-next-line
              this.props.birthday.length > 0 && !this.dateValidatonState() ? 'Provide correct date' : ''
            }
          {
              // eslint-disable-next-line
              this.props.birthday.length === 8 && (chekYears(this.props.birthday) <= 18 || chekYears(this.props.birthday) >= 75 || chekYears(this.props.birthday) === NaN) ?
              'Service permitted for 18-75 years old persons' : ''
            }
        </p>
        <Button
          onClick={this.saveBirthdayHandl}
          disabled={this.props.birthday.indexOf('') !== -1
            // eslint-disable-next-line
            || chekYears(this.props.birthday) <= 18
            || chekYears(this.props.birthday) >= 75
            || Number.isNaN(chekYears(this.props.birthday))
          }
        >
          Next
        </Button>
        <p className="birthday-info">
          We need it to prepare best proposals for you.
        </p>
      </div>
    );
  }
}

BirthdayPage.propTypes = {
  birthday: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  birthdayChangeHandl: PropTypes.func.isRequired,
  birthdaySend: PropTypes.func.isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  birthday: state.birthday.birthday,
  user: state.user.user
});

export default connect(mapStateToProps, containerActions)(BirthdayPage);



// WEBPACK FOOTER //
// ./src/pages/Birthday/index.js